import { isEqualContentDeepArrayUtil } from '../../array'

export default function isEqualUtil (obj1, obj2) {
  if (obj1 === obj2) {
    // If they are the same object, they are considered equal
    return true
  }

  if (obj1 === null || obj2 === null) {
    return false
  }

  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    // If one of them is not an object, they are not equal
    return false
  }

  if (Object.keys(obj1).length !== Object.keys(obj2).length) {
    // If they have a different number of properties, they are not equal
    return false
  }

  for (const key in obj1) {
    if (!(key in obj2)) {
      // If a key from obj1 is not in obj2, they are not equal
      return false
    }

    if (Array.isArray(obj1[key]) && Array.isArray(obj2[key]) && obj1[key] !== obj2[key]) {
      // Check if array are equal
      return isEqualContentDeepArrayUtil(obj1[key], obj2[key])
    }

    if (!isEqualUtil(obj1[key], obj2[key])) {
      // Recursively check the values
      return false
    }
  }

  return true
}
